(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@react-spring/web", "styled-components"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@react-spring/web"), require("styled-components"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.web, global.styledComponents);
    global.ViewElementTemplate = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _web, _styledComponents) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ViewElementTemplate = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);

  var _templateObject;

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  var ViewElementTemplate = (0, _styledComponents.default)(_web.animated.div)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  :not(& > &) {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow: auto;\n    background-color: #fff;\n    touch-action: pan-y;\n    user-select: none;\n  }\n\n  &[data-drag] {\n    z-index: 2;\n    pointer-events: none;\n  }\n  &[data-drag] + &[data-drag] {\n    display: block;\n    z-index: 1;\n  }\n"])));
  _exports.ViewElementTemplate = ViewElementTemplate;
});